import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bc70fc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-programs-all" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box-search" }
const _hoisted_4 = { class: "box-title" }
const _hoisted_5 = { class: "section-name" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "program" }
const _hoisted_8 = {
  key: 0,
  class: "box-pagination"
}

import { onMounted, reactive, ref } from 'vue';
  import { programStore } from '@/stores';
  import { useRouter, useRoute } from 'vue-router';
  import _ from 'lodash';
  import { useI18n } from 'vue-i18n';
  import { useMobileScrollMore } from '@/hooks/use-mobile-scroll-more';
  import qs from 'qs';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const breadcurmbRoutes = [
    {
      name: t('Home'),
      to: { name: 'home' }
    },
    {
      name: t('Program'),
      to: { name: 'programs.index' }
    },
    {
      name: t('all_program')
    }
  ];

  const router = useRouter();
  const route = useRoute();
  const keyword = ref(String(route.query.keyword || ''));

  const store = reactive(programStore);

  // vue bootstap 的change事件type可能有问题
  const handlePageChange = (page: any) => {
    router.replace({ query: { ...route.query, page } });
  };

  const handleSearch = (keyword: string) => {
    store.resetData();
    router.replace({ query: { ...route.query, keyword } });
  };

  onMounted(() => {
    const newQuery = _.pick(route.query, ['page', 'keyword']) as { page?: string; keyword?: string };
    // 判断参数是否一样
    if (JSON.stringify(newQuery) === JSON.stringify(store.query)) {
      store.tryFetchData();
      return;
    }
    store.updateQuery({
      page: newQuery.page ? Number(newQuery.page) : 1,
      keyword: newQuery.keyword,
    });
    store.fetchData();
  });

  useMobileScrollMore(async () => {
    await store.fetchMoreData();
    const newQuery = {
      ...route.query,
      page: store.meta.page,
    };
    history.replaceState(null, '', `${window.location.pathname}?${qs.stringify(newQuery)}`);
  });


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppCardProgram = _resolveComponent("AppCardProgram")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBreadcurmb, { routes: breadcurmbRoutes }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppSearch, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          onSearch: handleSearch
        }, null, 8, ["modelValue"])
      ]),
      (_unref(store).isEmpty)
        ? (_openBlock(), _createBlock(_component_AppEmptyView, {
            key: 0,
            text: keyword.value ? _unref(t)('No search results') : undefined,
            mode: keyword.value ? 'search' : 'data'
          }, null, 8, ["text", "mode"]))
        : (_unref(store).data.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(t)('all_program')), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "col-6 col-md-4"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_AppCardProgram, {
                        sm: "",
                        program: item
                      }, null, 8, ["program"])
                    ])
                  ]))
                }), 128))
              ]),
              (_unref(store).meta.total)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_AppPagination, {
                      total: _unref(store).meta.total,
                      "per-page": _unref(store).meta.per_page,
                      page: _unref(store).meta.page,
                      onChange: handlePageChange
                    }, null, 8, ["total", "per-page", "page"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})